// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"4a854844","64":"e0d4a769","563":"8c586e7b","787":"71e672d5"}[chunkId] + ".chunk.js";
};